import * as api from '@eventManager/api';
import * as MutationTypes from '../mutationTypes';
import { Event } from '../models';

export const eventListRequest = async ({ commit }) => {
  const response = await api.eventListRequest();
  const eventList = Event.toInstanceList(response.data.results);
  commit(MutationTypes.EVENT_LIST_SUCCESS, eventList);
};

export const createEventRequest = async ({ commit }, event) => {
  const serializedEvent = event.serialize();
  const response = await api.createEventRequest(serializedEvent);
  const newEvent = Event.toInstance(response.data);
  commit(MutationTypes.CREATE_EVENT_SUCCESS, newEvent);
};

export const updateEventRequest = async ({ commit }, event) => {
  const serializedEvent = event.serialize();
  const { guid } = serializedEvent;
  delete serializedEvent.guid;
  const response = await api.updateEventRequest(guid, serializedEvent);
  const newEvent = Event.toInstance(response.data);
  commit(MutationTypes.UPDATE_EVENT_SUCCESS, newEvent);
};

export const deleteEventRequest = async ({ commit }, event) => {
  await api.deleteEventRequest(event.guid);
  commit(MutationTypes.DELETE_EVENT_SUCCESS, event);
};
